const getCalendarTrackingProps = (preserveTripType, extra = {}) => ({
  calendar_variant: 'new',
  preserve_trip_type: Boolean(preserveTripType),
  ...extra,
});

export default getCalendarTrackingProps;
